<template>
  <div class="efactura-invoice-cell">
    <router-link :to="url" class="efactura-invoice-no text-inherit hover:text-primary">{{ params.value }}</router-link>
    <!-- Les tags disent d'où vient le document, donc quelle variante de XML
         partira : une note de crédit et une facture borne ne se génèrent pas
         comme une facture ERP. -->
    <span v-if="data.iscreditnote" class="efactura-tag efactura-tag--storno">STORNO</span>
    <!-- « FIREWOOD » et non « BOIS » : tout ce que vend XYLO est du bois. Ce
         tag désigne l'origine borne bois de feu (xml_macdo), pas la matière. -->
    <span v-if="data.is_firewood" class="efactura-tag efactura-tag--firewood">FIREWOOD</span>
    <!-- Le motif de blocage vit ICI, pas dans une colonne de droite qu'il faut
         aller chercher au scroll : c'est sur cette ligne que l'opérateur cherche
         pourquoi il ne peut pas la cocher. -->
    <span v-if="reason" class="efactura-lock" :title="reason">
      <feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'CellRendererInvoice',
  computed: {
    data () {
      return this.params.data || {}
    },
    reason () {
      return this.data.blocked_reason || ''
    },
    url () {
      return "/invoice/" + this.data.id
    }
  }
}
</script>

<style scoped>
.efactura-invoice-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

/* Si la place manque, c'est le numéro qui s'élide — jamais le tag, qui ne fait
   sens qu'entier (« FIREWO » ne veut rien dire). */
.efactura-invoice-no {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Pas de vs-chip ici : la classe .ag-grid-cell-chip du thème positionne la puce
   avec top:50% + translateY(-50%), ce qui ne tombe juste que si elle est SEULE
   dans la cellule — à côté d'un autre élément, elle sort de la ligne et se fait
   couper. Un simple <span> reste dans le flux. */
.efactura-tag {
  flex: 0 0 auto;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1.6;
  color: #fff;
}

.efactura-tag--storno { background-color: #ff9f43; }
.efactura-tag--firewood { background-color: #7da7bc; }

.efactura-lock {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  color: #ff9f43;
  cursor: help;
}
</style>
